module.exports = __webpack_public_path__ + "img/guohui.58f55c5c.png";